import store from '@/store';

import { VendorUserService } from '@/core/vendor-user';

const isAuthenticated = {
  check: () => store.getters.hasAuthToken,
  redirectOnFail: {
    name: 'login',
  },
};

const isNotAuthenticated = {
  check: () => !store.getters.hasAuthToken,
  redirectOnFail: {
    name: 'redirect',
  },
};

const isNotConfirmed = {
  check: () => {
    const { user } = store.state;
    return user && user.uuid && !user.confirmed;
  },
  redirectOnFail: {
    name: 'redirect',
  },
};

const hasNoVendor = {
  check: async () => {
    const { user } = store.state;
    const vendorUser = _.get(store.state, 'vendorUser') || await VendorUserService.get(user.uuid);
    return !_.get(vendorUser, 'vendor.uuid');
  },
  redirectOnFail: {
    name: 'redirect',
  },
};

export default {
  isAuthenticated,
  isNotAuthenticated,
  isNotConfirmed,
  hasNoVendor,
};
